import { formatAmountINR } from "../../../../../shared/utils/amountFormat";
import { formatDateToDDMMYYYY } from "../../../../../shared/utils/dateFormat";

export const getTextFields = (paymentData: any) => {
  const student = paymentData?.studentClass?.student;
  const studentClass = paymentData?.studentClass?.class;

  return [
    {
      id: "student-name",
      name: "studentName",
      label: "Student Name",
      type: "text",
      placeholder: "N/A",
      required: false,
      disabled: true,
      capitalizedFirst: true,
      value: student?.name || "N/A",
    },
    {
      id: "student-admission-number",
      name: "admissionNumber",
      label: "Admission Number",
      type: "text",
      placeholder: "N/A",
      required: false,
      disabled: true,
      value: student?.admissionNumber || "N/A",
    },
    {
      id: "student-phone",
      name: "phone",
      label: "Phone",
      type: "text",
      placeholder: "N/A",
      required: false,
      disabled: true,
      value: student?.phone || "N/A",
    },
    {
      id: "class",
      name: "class",
      label: "Class",
      type: "text",
      placeholder: "N/A",
      required: false,
      disabled: true,
      value: studentClass?.displayName || "N/A",
    },
    {
      id: "division",
      name: "division",
      label: "Division",
      type: "text",
      placeholder: "N/A",
      required: false,
      disabled: true,
      value: paymentData?.studentClass?.division || "N/A",
    },
    {
      id: "roll-number",
      name: "rollNumber",
      label: "Roll Number",
      type: "text",
      placeholder: "N/A",
      required: false,
      disabled: true,
      value: paymentData?.studentClass?.rollNumber || "N/A",
    },
    {
      id: "payment-date",
      name: "paymentDate",
      label: "Payment Date",
      type: "text",
      placeholder: "N/A",
      required: false,
      disabled: true,
      value: formatDateToDDMMYYYY(paymentData?.paymentDate),
    },    
    {
      id: "payment-mode",
      name: "paymentMode",
      label: "Payment Mode",
      type: "text",
      placeholder: "N/A",
      required: false,
      disabled: true,
      value: paymentData?.paymentMode || "N/A",
    },
    {
      id: "receipt-number",
      name: "receiptNumber",
      label: "Receipt Number",
      type: "text",
      placeholder: "N/A",
      required: false,
      disabled: true,
      value: paymentData?.receiptNumber || "N/A",
    },
    {
      id: "amount-paid",
      name: "amount",
      label: "Amount Paid",
      type: "text",
      placeholder: "N/A",
      required: false,
      disabled: true,
      value: formatAmountINR(paymentData?.amount) || "N/A",
    },
  ];
};
